import { connect } from 'react-redux';
import EditSpecializations from 'profile/components/edit_specializations';

export function mapStateToProps(state) {
  const isClient = state.profile.view.data.is_client;

  return { isClient };
}

export default connect(mapStateToProps)(EditSpecializations);



// WEBPACK FOOTER //
// ./profile/containers/edit_specializations.js